<template>
  <g id="Seat-4" v-on:click="changeSeverity('rearSeat')" :class="severityClass">
    <path
      class="cls-614"
      d="M76.7,264.38l-14.79,1.43c-.65,.06-1.31,.06-1.96,0l-14.79-1.43c-1.77,0-3.07-1.91-2.62-3.87l2.05-9.04c.31-1.37,1.39-2.32,2.62-2.32l13.72-.25,13.72,.25c1.23,0,2.31,.95,2.62,2.32l2.05,9.04c.44,1.96-.85,3.87-2.62,3.87Z"
    />
    <path
      class="cls-611"
      d="M74.2,261.39l-12.45,1.12c-.55,.05-1.1,.05-1.65,0l-12.45-1.12c-1.49,0-2.58-1.5-2.21-3.04l1.72-7.1c.26-1.07,1.17-1.82,2.21-1.82l11.55-.21,11.55,.21c1.04,0,1.95,.75,2.21,1.82l1.72,7.1c.37,1.54-.72,3.04-2.21,3.04Z"
    />
    <path
      class="cls-1"
      d="M71.21,260.04l-10.07,.97c-.14,.01-.29,.01-.43,0l-10.07-.97c-1.16,0-2-1.16-1.71-2.35l1.34-5.5c.2-.83,.91-1.41,1.71-1.41l8.95-.37,8.95,.37c.81,0,1.51,.58,1.71,1.41l1.34,5.5c.29,1.19-.56,2.35-1.71,2.35Z"
    />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
